import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import ReactGA from "react-ga4";
import { useState, useEffect } from "react";
import { fetchUserRepos, transformRepoToProject } from "../utils/githubService";

ReactGA.initialize("G-NY8FSE5QD1");

export const Projects = () => {
  const [githubRepos, setGithubRepos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastFetch, setLastFetch] = useState(null);
  const [showAllProjects, setShowAllProjects] = useState(false);
  const INITIAL_PROJECTS_COUNT = 9;

  useEffect(() => {
    const loadGitHubRepos = async () => {
      try {
        setLoading(true);
        setError(null);

        const repos = await fetchUserRepos('Ushan2001', 100);

        const filteredRepos = repos
          .filter(repo => !repo.fork)
          .sort((a, b) => {
            if (b.stargazers_count !== a.stargazers_count) {
              return b.stargazers_count - a.stargazers_count;
            }
            return new Date(b.updated_at) - new Date(a.updated_at);
          })

        const transformedRepos = filteredRepos.map(transformRepoToProject);
        setGithubRepos(transformedRepos);
        setLastFetch(new Date());

      } catch (err) {
        console.error('Failed to load GitHub repos:', err);
        setError('Failed to load GitHub repositories. Showing cached projects.');
      } finally {
        setLoading(false);
      }
    };

    loadGitHubRepos();
  }, []);

  // Static professional projects (keep these)
  const professionalProjects = [
    {
      title: "EduOne",
      description:
        'Educational platform with quality learning resources and interactive tools. <a href="https://eduone.lk/" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'Node.js', 'MongoDB'],
      category: 'professional'
    },
    {
      title: "FEDES AI",
      description:
        'Emotion detection tool for educators powered by AI technology. <br/><a href="https://fedesai.com/" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['AI/ML', 'Python', 'React.js'],
      category: 'professional'
    },
    {
      title: "ExamHUB",
      description:
        'Gaming education platform with modern technologies for interactive learning. <br/><a href="https://examhub.lk/" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'Node.js', 'MongoDB'],
      category: 'professional'
    },
    {
      title: "Fonix Software Solution Landing Page",
      description:
        'Clean and user-friendly landing page for Fonix Software Solution. <a href="https://www.fonixss.com/" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'CSS3'],
      category: 'professional'
    },
    {
      title: "School Management System",
      description:
        'Comprehensive school management system using React.js, Node.js, and MongoDB. <br/><a href="https://github.com/Ushan2001/School-Management-System" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'Node.js', 'MongoDB'],
      category: 'fullstack'
    },
    {
      title: "Health Care Management System",
      description:
        'Health care management system built using HTML, CSS, PHP, and SQL. <br/><a href="https://github.com/Ushan2001/Health-Care-Management-System" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['PHP', 'MySQL', 'HTML/CSS'],
      category: 'fullstack'
    },
    {
      title: "Buy Sell Nexus",
      description:
        'A 3rd year project — a digital platform for buying and selling. <br/><a href="https://github.com/Ushan2001/ITPM" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'Node.js', 'MongoDB'],
      category: 'fullstack'
    },
    {
      title: "Skill Swap Learning Web Application",
      description:
        'A web app for connecting people to share and learn skills in a dynamic community. <br/><a href="https://github.com/Ushan2001/PAF_PRO" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'Node.js'],
      category: 'fullstack'
    },
    {
      title: "Buying & Selling Management System",
      description:
        'Digital commerce revolution for buying and selling. <br/><a href="https://github.com/Ushan2001/Buying-And-Selling" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['PHP', 'MySQL'],
      category: 'fullstack'
    },
    {
      title: "Online Spare Part Management System",
      description:
        'Efficient management system for online spare parts transactions. <br/><a href="https://github.com/Ushan2001/Online-Spare-Parts-Management-System" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['PHP', 'MySQL'],
      category: 'fullstack'
    },
    {
      title: "Event Photography Management System",
      description:
        'Event photography management system using HTML, CSS, PHP, and SQL. <br/><a href="https://github.com/Ushan2001/Online-Spare-Parts-Management-System" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['PHP', 'MySQL', 'HTML/CSS'],
      category: 'fullstack'
    },
    {
      title: "AI Powered Chat Bot",
      description:
        'AI chatbot powered by Node.js, React.js, and Hugging Face Llama. <br/><a href="https://github.com/Ushan2001/AI-Chat-Bot" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['AI/ML', 'Node.js', 'React.js'],
      category: 'specialized'
    },
    {
      title: "Real-time Chat Application",
      description:
        'Live real-time chat application built with React, Node.js, and Socket.io. <br/><a href="https://github.com/Ushan2001/AI-Chat-Bot" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'Node.js', 'Socket.io'],
      category: 'specialized'
    },
    {
      title: "Mathematics Quiz Game & Todo App",
      description:
        'Android math quiz app to test speed and todo management. <br/><a href="https://github.com/Ushan2001/Simple-Math-Quiz-Game" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['Kotlin', 'Android'],
      category: 'specialized'
    },
    {
      title: "Facebook Clone Interface",
      description:
        'Facebook clone interface built with React.js for learning. <br/><a href="https://github.com/Ushan2001/facebookclone" target="_blank" rel="noopener noreferrer"></a>',
      tech: ['React.js', 'CSS3'],
      category: 'specialized'
    },
  ];

  // Combine professional projects with GitHub repos
  const allProjects = [...professionalProjects, ...githubRepos];

  const handleProjectClick = (projectTitle) => {
    ReactGA.event({
      category: "Project Click",
      action: `Clicked ${projectTitle}`,
      label: `${projectTitle} Link`,
    });
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects & others</h2>
                  <p>
                    I specialize in designing and developing a variety of
                    projects, ranging from buying and management systems to
                    engaging quiz games and online spare part management
                    solutions. Each project demonstrates my commitment to
                    creating innovative, user-friendly experiences tailored to
                    meet specific needs and challenges.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link
                          eventKey="first"
                          style={{ cursor: "pointer" }}
                        >
                          Projects
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="second"
                          style={{ cursor: "pointer" }}
                        >
                          About
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="third"
                          style={{ cursor: "pointer" }}
                        >
                          Certificates
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        {/* Header */}
                        <div style={{
                          textAlign: 'center',
                          marginBottom: '40px'
                        }}>
                          <h3 style={{
                            color: '#fff',
                            fontSize: '32px',
                            fontWeight: '700',
                            marginBottom: '15px'
                          }}>
                            🚀 Featured Projects
                          </h3>
                          <p style={{
                            color: '#B8B8B8',
                            fontSize: '16px',
                            maxWidth: '700px',
                            margin: '0 auto',
                            lineHeight: '1.6'
                          }}>
                            A showcase of my work spanning professional projects, full-stack applications, and specialized solutions. Each project demonstrates my commitment to creating innovative, user-friendly experiences.
                          </p>
                        </div>

                        <Row style={{ rowGap: '30px' }}>
                          {loading && (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#B8B8B8' }}>
                              <div style={{ fontSize: '24px', marginBottom: '10px' }}>🔄</div>
                              <p>Loading live GitHub repositories...</p>
                            </div>
                          )}
                          {error && (
                            <div style={{ textAlign: 'center', padding: '15px', background: 'rgba(255, 100, 100, 0.1)', borderRadius: '10px', marginBottom: '20px', border: '1px solid rgba(255, 100, 100, 0.3)' }}>
                              <p style={{ color: '#ff6b6b', margin: 0, fontSize: '14px' }}>{error}</p>
                            </div>
                          )}
                          {lastFetch && !loading && githubRepos.length > 0 && (
                            <div style={{ textAlign: 'center', color: '#888', fontSize: '13px', marginBottom: '25px', fontStyle: 'italic', padding: '10px', background: 'rgba(255, 255, 255, 0.03)', borderRadius: '8px' }}>
                              🔄 Live data from GitHub • Last updated: {lastFetch.toLocaleTimeString()} • Showing {showAllProjects ? allProjects.length : Math.min(INITIAL_PROJECTS_COUNT, allProjects.length)} of {allProjects.length} projects
                            </div>
                          )}
                          {(showAllProjects ? allProjects : allProjects.slice(0, INITIAL_PROJECTS_COUNT)).map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                onClick={() =>
                                  handleProjectClick(project.title)
                                }
                              />
                            );
                          })}
                        </Row>

                        {/* See More Button */}
                        {!showAllProjects && allProjects.length > INITIAL_PROJECTS_COUNT && (
                          <div style={{
                            textAlign: 'center',
                            marginTop: '40px'
                          }}>
                            <button
                              onClick={() => setShowAllProjects(true)}
                              style={{
                                background: 'linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)',
                                border: 'none',
                                color: '#fff',
                                padding: '16px 40px',
                                borderRadius: '30px',
                                fontSize: '16px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 8px 25px rgba(170, 54, 124, 0.4)',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '10px'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-3px) scale(1.05)';
                                e.target.style.boxShadow = '0 12px 35px rgba(170, 54, 124, 0.6)';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0) scale(1)';
                                e.target.style.boxShadow = '0 8px 25px rgba(170, 54, 124, 0.4)';
                              }}
                            >
                              <span>See More Projects</span>
                              <span style={{ fontSize: '20px', transition: 'transform 0.3s ease' }}>↓</span>
                            </button>
                            <p style={{
                              color: '#888',
                              fontSize: '14px',
                              marginTop: '15px',
                              fontStyle: 'italic'
                            }}>
                              {allProjects.length - INITIAL_PROJECTS_COUNT} more projects available
                            </p>
                          </div>
                        )}

                        {/* Show Less Button */}
                        {showAllProjects && allProjects.length > INITIAL_PROJECTS_COUNT && (
                          <div style={{
                            textAlign: 'center',
                            marginTop: '40px'
                          }}>
                            <button
                              onClick={() => {
                                setShowAllProjects(false);
                                // Scroll back to projects section
                                document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
                              }}
                              style={{
                                background: 'rgba(255, 255, 255, 0.1)',
                                border: '2px solid rgba(170, 54, 124, 0.5)',
                                color: '#fff',
                                padding: '16px 40px',
                                borderRadius: '30px',
                                fontSize: '16px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '10px',
                                backdropFilter: 'blur(10px)'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-3px) scale(1.05)';
                                e.target.style.background = 'rgba(170, 54, 124, 0.3)';
                                e.target.style.boxShadow = '0 12px 35px rgba(170, 54, 124, 0.4)';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0) scale(1)';
                                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)';
                              }}
                            >
                              <span style={{ fontSize: '20px', transition: 'transform 0.3s ease' }}>↑</span>
                              <span>Show Less</span>
                            </button>
                          </div>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <div style={{ padding: '20px 0' }}>
                          {/* Professional Summary */}
                          <div style={{
                            background: 'linear-gradient(90.21deg, rgba(170, 54, 124, 0.5) -5.91%, rgba(74, 47, 189, 0.5) 111.58%)',
                            borderRadius: '15px',
                            padding: '30px',
                            marginBottom: '30px',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                            backdropFilter: 'blur(4px)',
                            border: '1px solid rgba(255, 255, 255, 0.18)'
                          }}>
                            <h3 style={{
                              color: '#fff',
                              marginBottom: '20px',
                              fontSize: '28px',
                              fontWeight: '700'
                            }}>
                              👋 Hello! I'm Ushan Mihiranga
                            </h3>
                            <p style={{
                              color: '#fff',
                              fontSize: '16px',
                              lineHeight: '1.8',
                              marginBottom: '0'
                            }}>
                              A passionate <b>third-year Software Engineering student</b> at SLIIT and <b>Full Stack Developer</b> at FonixEdu Pvt Ltd by Atlas Axillia. I specialize in creating seamless user experiences through modern front-end design and robust back-end functionality. My focus is on leveraging technology to solve real-world problems and contribute to the tech industry's innovation.
                            </p>
                          </div>

                          {/* Work Experience */}
                          <div style={{
                            background: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '15px',
                            padding: '25px',
                            marginBottom: '25px',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            transition: 'transform 0.3s ease',
                          }}>
                            <h4 style={{
                              color: '#fff',
                              marginBottom: '15px',
                              fontSize: '22px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px'
                            }}>
                              💼 Work Experience
                            </h4>
                            <div style={{ color: '#B8B8B8', fontSize: '15px', lineHeight: '1.8' }}>
                              <p style={{ marginBottom: '10px' }}>
                                <b style={{ color: '#fff', fontSize: '18px' }}>Full Stack Web Developer</b><br />
                                <span style={{ color: '#AA367C' }}>FonixEdu Pvt Ltd by Atlas Axillia</span> | Feb 2024 - Present
                              </p>
                              <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                <li>Developing responsive web applications and landing pages</li>
                                <li>Building admin dashboards and client-side interfaces</li>
                                <li>Creating RESTful APIs and backend services</li>
                                <li>Integrating payment gateways and third-party services</li>
                                <li>Implementing real-time features using WebSocket</li>
                              </ul>
                            </div>
                          </div>

                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                            {/* Education */}
                            <div style={{
                              background: 'rgba(255, 255, 255, 0.05)',
                              borderRadius: '15px',
                              padding: '25px',
                              border: '1px solid rgba(255, 255, 255, 0.1)',
                            }}>
                              <h4 style={{
                                color: '#fff',
                                marginBottom: '15px',
                                fontSize: '22px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                              }}>
                                🎓 Education
                              </h4>
                              <div style={{ color: '#B8B8B8', fontSize: '15px', lineHeight: '1.8' }}>
                                <p style={{ marginBottom: '15px' }}>
                                  <b style={{ color: '#fff' }}>BSc (Hons) in Information Technology</b><br />
                                  Specializing in Software Engineering<br />
                                  SLIIT | 2022 - Present
                                </p>
                                <p style={{ marginBottom: '0' }}>
                                  <b style={{ color: '#fff' }}>G.C.E Advanced Level</b><br />
                                  Physical Science - <b style={{ color: '#AA367C' }}>C3</b><br />
                                  St. Aloysius College, Rathnapura | 2020
                                </p>
                              </div>
                            </div>

                            {/* Skills Highlights */}
                            <div style={{
                              background: 'rgba(255, 255, 255, 0.05)',
                              borderRadius: '15px',
                              padding: '25px',
                              border: '1px solid rgba(255, 255, 255, 0.1)',
                            }}>
                              <h4 style={{
                                color: '#fff',
                                marginBottom: '15px',
                                fontSize: '22px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                              }}>
                                🚀 Skills Highlights
                              </h4>
                              <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px',
                                marginTop: '15px'
                              }}>
                                {['React.js', 'Node.js', 'MongoDB', 'Express.js', 'React Native', 'AWS', 'Azure', 'Docker'].map((skill, idx) => (
                                  <span key={idx} style={{
                                    background: 'linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)',
                                    color: '#fff',
                                    padding: '8px 16px',
                                    borderRadius: '20px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    boxShadow: '0 4px 15px 0 rgba(170, 54, 124, 0.3)'
                                  }}>
                                    {skill}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Certifications Summary */}
                          <div style={{
                            background: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '15px',
                            padding: '25px',
                            marginTop: '25px',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            textAlign: 'center'
                          }}>
                            <h4 style={{
                              color: '#fff',
                              marginBottom: '15px',
                              fontSize: '22px'
                            }}>
                              🏆 Certifications
                            </h4>
                            <p style={{ color: '#B8B8B8', fontSize: '15px', marginBottom: '15px' }}>
                              Certified in AWS, Microsoft Azure, and Google Cloud & AI
                            </p>
                            <button
                              onClick={() => {
                                const certificatesTab = document.querySelector('[data-rr-ui-event-key="third"]');
                                if (certificatesTab) certificatesTab.click();
                              }}
                              style={{
                                background: 'linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)',
                                color: '#fff',
                                border: 'none',
                                padding: '12px 30px',
                                borderRadius: '25px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease',
                                boxShadow: '0 4px 15px 0 rgba(170, 54, 124, 0.4)'
                              }}
                              onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                              onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                            >
                              View All Certificates →
                            </button>
                          </div>

                          {/* Contact Information */}
                          <div style={{
                            background: 'linear-gradient(90.21deg, rgba(170, 54, 124, 0.5) -5.91%, rgba(74, 47, 189, 0.5) 111.58%)',
                            borderRadius: '15px',
                            padding: '30px',
                            marginTop: '30px',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                            backdropFilter: 'blur(4px)',
                            border: '1px solid rgba(255, 255, 255, 0.18)'
                          }}>
                            <h4 style={{
                              color: '#fff',
                              marginBottom: '20px',
                              fontSize: '22px',
                              textAlign: 'center'
                            }}>
                              📞 Let's Connect!
                            </h4>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                              gap: '15px',
                              color: '#fff',
                              fontSize: '15px'
                            }}>
                              <div>
                                <b>📱 Phone:</b><br />
                                <a href="tel:+94760673035" style={{ color: '#fff', textDecoration: 'none' }}>
                                  +94 760 673 035
                                </a>
                              </div>
                              <div>
                                <b>📧 Email:</b><br />
                                <a href="mailto:ushanmihiranga2017@gmail.com" style={{ color: '#fff', textDecoration: 'none' }}>
                                  ushanmihiranga2017@gmail.com
                                </a>
                              </div>
                              <div>
                                <b>📍 Address:</b><br />
                                168/6 First Lane, Welivita Road, Malabe
                              </div>
                              <div>
                                <b>💼 LinkedIn:</b><br />
                                <a
                                  href="https://www.linkedin.com/in/ushan-mihiranga-b25846296"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: '#fff', textDecoration: 'underline' }}
                                >
                                  View Profile
                                </a>
                              </div>
                              <div>
                                <b>💻 GitHub:</b><br />
                                <a
                                  href="https://github.com/Ushan2001"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: '#fff', textDecoration: 'underline' }}
                                >
                                  @Ushan2001
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="third">
                        <div style={{ padding: '20px 0' }}>
                          {/* Header */}
                          <div style={{
                            textAlign: 'center',
                            marginBottom: '40px'
                          }}>
                            <h3 style={{
                              color: '#fff',
                              fontSize: '32px',
                              fontWeight: '700',
                              marginBottom: '15px'
                            }}>
                              🏆 Professional Certifications
                            </h3>
                            <p style={{
                              color: '#B8B8B8',
                              fontSize: '16px',
                              maxWidth: '600px',
                              margin: '0 auto'
                            }}>
                              Continuously upskilling in cloud technologies and AI to stay at the forefront of innovation
                            </p>
                          </div>

                          {/* AWS SimuLearn Series */}
                          <div style={{
                            background: 'linear-gradient(90.21deg, rgba(255, 153, 0, 0.3) -5.91%, rgba(255, 102, 0, 0.3) 111.58%)',
                            borderRadius: '15px',
                            padding: '30px',
                            marginBottom: '30px',
                            border: '1px solid rgba(255, 153, 0, 0.3)',
                            boxShadow: '0 8px 32px 0 rgba(255, 153, 0, 0.2)'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '15px',
                              marginBottom: '20px'
                            }}>
                              <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
                                alt="AWS"
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  filter: 'brightness(0) invert(1)'
                                }}
                              />
                              <h4 style={{
                                color: '#fff',
                                fontSize: '24px',
                                fontWeight: '700',
                                margin: '0'
                              }}>
                                AWS SimuLearn Series
                              </h4>
                            </div>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                              gap: '15px'
                            }}>
                              {[
                                'Core Security Concepts',
                                'Databases in Practice',
                                'Auto-Healing & Scaling Applications',
                                'Highly Available Web Applications',
                                'File Systems in the Cloud',
                                'Amazon S3 – Introduction'
                              ].map((cert, idx) => (
                                <div key={idx} style={{
                                  background: 'rgba(255, 255, 255, 0.1)',
                                  padding: '15px 20px',
                                  borderRadius: '10px',
                                  color: '#fff',
                                  fontSize: '15px',
                                  fontWeight: '500',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'transform 0.2s ease',
                                  cursor: 'default'
                                }}>
                                  <span style={{ fontSize: '20px' }}>✓</span>
                                  {cert}
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Microsoft Azure Fundamentals */}
                          <div style={{
                            background: 'linear-gradient(90.21deg, rgba(0, 120, 212, 0.3) -5.91%, rgba(0, 90, 158, 0.3) 111.58%)',
                            borderRadius: '15px',
                            padding: '30px',
                            marginBottom: '30px',
                            border: '1px solid rgba(0, 120, 212, 0.3)',
                            boxShadow: '0 8px 32px 0 rgba(0, 120, 212, 0.2)'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '15px',
                              marginBottom: '20px'
                            }}>
                              <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg"
                                alt="Azure"
                                style={{
                                  width: '50px',
                                  height: '50px'
                                }}
                              />
                              <h4 style={{
                                color: '#fff',
                                fontSize: '24px',
                                fontWeight: '700',
                                margin: '0'
                              }}>
                                Microsoft Azure Fundamentals
                              </h4>
                            </div>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                              gap: '15px'
                            }}>
                              {[
                                'Describe Azure Identity, Access & Security',
                                'Explore Relational Database Services in Azure',
                                'Improve Scalability & Resiliency with Azure Load Balancer',
                                'Configure Azure Blob Storage',
                                'Add & Size Disks in Azure Virtual Machines'
                              ].map((cert, idx) => (
                                <div key={idx} style={{
                                  background: 'rgba(255, 255, 255, 0.1)',
                                  padding: '15px 20px',
                                  borderRadius: '10px',
                                  color: '#fff',
                                  fontSize: '15px',
                                  fontWeight: '500',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'transform 0.2s ease',
                                  cursor: 'default'
                                }}>
                                  <span style={{ fontSize: '20px' }}>✓</span>
                                  {cert}
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Google Cloud & AI Certifications */}
                          <div style={{
                            background: 'linear-gradient(90.21deg, rgba(66, 133, 244, 0.3) -5.91%, rgba(52, 168, 83, 0.3) 111.58%)',
                            borderRadius: '15px',
                            padding: '30px',
                            marginBottom: '30px',
                            border: '1px solid rgba(66, 133, 244, 0.3)',
                            boxShadow: '0 8px 32px 0 rgba(66, 133, 244, 0.2)'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '15px',
                              marginBottom: '20px'
                            }}>
                              <img
                                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg"
                                alt="Google Cloud"
                                style={{
                                  width: '50px',
                                  height: '50px'
                                }}
                              />
                              <h4 style={{
                                color: '#fff',
                                fontSize: '24px',
                                fontWeight: '700',
                                margin: '0'
                              }}>
                                Google Cloud & AI Certifications
                              </h4>
                            </div>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                              gap: '15px'
                            }}>
                              {[
                                'Introduction to Generative AI',
                                'Introduction to Large Language Models',
                                'Introduction to Responsible AI',
                                'Responsible AI: Applying AI Principles with Google Cloud'
                              ].map((cert, idx) => (
                                <div key={idx} style={{
                                  background: 'rgba(255, 255, 255, 0.1)',
                                  padding: '15px 20px',
                                  borderRadius: '10px',
                                  color: '#fff',
                                  fontSize: '15px',
                                  fontWeight: '500',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'transform 0.2s ease',
                                  cursor: 'default'
                                }}>
                                  <span style={{ fontSize: '20px' }}>✓</span>
                                  {cert}
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Summary Stats */}
                          <div style={{
                            background: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '15px',
                            padding: '30px',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            textAlign: 'center'
                          }}>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                              gap: '30px',
                              maxWidth: '600px',
                              margin: '0 auto'
                            }}>
                              <div>
                                <div style={{
                                  fontSize: '36px',
                                  fontWeight: '700',
                                  color: '#AA367C',
                                  marginBottom: '5px'
                                }}>
                                  15+
                                </div>
                                <div style={{
                                  color: '#B8B8B8',
                                  fontSize: '14px'
                                }}>
                                  Total Certifications
                                </div>
                              </div>
                              <div>
                                <div style={{
                                  fontSize: '36px',
                                  fontWeight: '700',
                                  color: '#AA367C',
                                  marginBottom: '5px'
                                }}>
                                  3
                                </div>
                                <div style={{
                                  color: '#B8B8B8',
                                  fontSize: '14px'
                                }}>
                                  Cloud Platforms
                                </div>
                              </div>
                              <div>
                                <div style={{
                                  fontSize: '36px',
                                  fontWeight: '700',
                                  color: '#AA367C',
                                  marginBottom: '5px'
                                }}>
                                  4
                                </div>
                                <div style={{
                                  color: '#B8B8B8',
                                  fontSize: '14px'
                                }}>
                                  AI Certifications
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="profile" />
    </section>
  );
};
